var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { grey } from '@material-ui/core/colors';
import InfiniteScroll from 'react-infinite-scroller';
import { getTranslate } from 'react-localize-redux';
import { List as ImuList } from 'immutable';
// - Import app components
import PostComponent from 'src/components/post';
import LoadMoreProgressComponent from 'src/layouts/loadMoreProgress';
// - Import API
import * as PostAPI from 'src/api/PostAPI';
// - Import actions
import * as globalActions from 'src/store/actions/globalActions';
import './stream.css';
import './stream2.css';
// var background = require('../../containers/home/possibleBackgrounds/Ice1.jpg')
// - Create StreamComponent component class
var Iceshirt = require('../../assets/Models/ice.glb');
var StreamComponent = /** @class */ (function (_super) {
    __extends(StreamComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function StreamComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            postWritePrimaryText: {
                color: grey[400],
                cursor: 'text'
            },
            postWtireItem: {
                fontWeight: '200'
            },
            primaryImage: {
                backgroundImage: "url(https://firebasestorage.googleapis.com/v0/b/fileupload-test-93e98.appspot.com/o/WebsiteFileControl%2Fhome.jpg?alt=media&token=1ef058d6-ea40-4362-89e8-0c9b18b2b644)",
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%',
                height: '720px',
            }
        };
        /**
         * Open post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleOpenPostWrite = function () {
            _this.setState({
                openPostWrite: true
            });
        };
        /**
         * Close post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleClosePostWrite = function () {
            _this.setState({
                openPostWrite: false
            });
        };
        /**
         * Create a list of posts
         * @return {DOM} posts
         */
        _this.postLoad = function (Type, property) {
            var match = _this.props.match;
            var posts = _this.props.posts;
            var tag = match.params.tag;
            if (posts === undefined || !(posts.keySeq().count() > 0)) {
                return (React.createElement("h1", null, "'Nothing has shared.'"));
            }
            else {
                var postBack_1 = { divided: false, oddPostList: [], evenPostList: [], threePostList: [], fourPostList: [], allPostList: [] };
                var parsedPosts_1 = ImuList();
                posts.forEach(function (post) {
                    if (tag) {
                        var regex = new RegExp('#' + tag, 'g');
                        var postMatch = String(post.get('body', '')).match(regex);
                        if (postMatch !== null) {
                            parsedPosts_1 = parsedPosts_1.push(post);
                        }
                    }
                    else {
                        parsedPosts_1 = parsedPosts_1.push(post);
                    }
                });
                var sortedPosts = PostAPI.sortImuObjectsAvailable(parsedPosts_1);
                if (sortedPosts.count() > -1) {
                    postBack_1.divided = true;
                }
                else {
                    postBack_1.divided = false;
                }
                var filtered = void 0;
                if (property && Type) {
                    filtered = sortedPosts.filter(function (post) {
                        return post.get('Type') === 'Costumes';
                    });
                }
                else {
                    filtered = sortedPosts;
                }
                filtered.forEach(function (post) {
                    // if (post!.get('Type') === 'Sweaters') {
                    var newPost = (React.createElement("div", { className: '', key: post.get('id') + "-stream-div" },
                        React.createElement(PostComponent, { FontColor: 'black', key: post.get('id') + "-stream-div-post", post: post })));
                    postBack_1.allPostList.push(newPost);
                    // }
                });
                return postBack_1;
            }
        };
        /**
         * Scroll loader
         */
        _this.scrollLoad = function (page) {
            var loadStream = _this.props.loadStream;
            loadStream(page, 6);
        };
        _this.printstuff = function () {
        };
        _this.state = {
            /**
             * It's true if we want to have two column of posts
             */
            divided: false,
            /**
             * If it's true comment will be disabled on post
             */
            disableComments: _this.props.disableComments,
            /**
             * If it's true share will be disabled on post
             */
            disableSharing: _this.props.disableSharing,
            /**
             * If it's true, post write will be open
             */
            openPostWrite: false,
            /**
             * The title of home header
             */
            homeTitle: props.homeTitle,
            /**
             * If there is more post to show {true} or not {false}
             */
            hasMorePosts: true,
            AllPosts: []
        };
        // Binding functions to `this`
        _this.postLoad = _this.postLoad.bind(_this);
        _this.handleOpenPostWrite = _this.handleOpenPostWrite.bind(_this);
        _this.handleClosePostWrite = _this.handleClosePostWrite.bind(_this);
        return _this;
    }
    StreamComponent.prototype.componentDidMount = function () {
    };
    StreamComponent.prototype.componentWillMount = function () {
        var setHomeTitle = this.props.setHomeTitle;
        setHomeTitle();
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    StreamComponent.prototype.render = function () {
        var Directories = [
            {
                Src: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/110933675-stack-of-folded-warm-knitted-sweaters-closeup.jpg?alt=media&token=d9a8865e-e323-46ac-9f63-f821d55b9664',
                Route: 'Sweaters',
                Title: 'Sweaters'
            },
            {
                Src: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/Coats-min.png?alt=media&token=fc32328d-1b37-4e4e-94f7-7a0bf1d27f0b',
                Route: 'Coats',
                Title: 'Coats'
            },
            {
                Src: 'https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1558112879-hanes-ali-markarian-1558112868.jpg',
                Route: 'tshirts',
                Title: 'T-shirts'
            },
            {
                Src: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/Denim1%20(1).png?alt=media&token=62825c1b-ba63-4704-af3c-66b760a2a85e',
                Route: 'Denim',
                Title: 'Denim'
            }
        ];
        var _a = this.props, tag = _a.tag, displayWriting = _a.displayWriting, hasMorePosts = _a.hasMorePosts, translate = _a.translate;
        var postList = this.postLoad();
        if (window.outerWidth > 500) {
            return (React.createElement(InfiniteScroll
            // style={{ overflowX: 'hidden' }}
            , { 
                // style={{ overflowX: 'hidden' }}
                pageStart: 0, loadMore: this.scrollLoad, hasMore: this.state.hasMorePosts, useWindow: true, loader: React.createElement(LoadMoreProgressComponent, { key: 'stream-load-more-progress' }) },
                React.createElement("div", { style: {} }, displayWriting && !tag && this.props.isDesigner
                    ? (React.createElement("div", { style: { display: 'block', textAlign: 'center', width: '50%', margin: 'auto', marginTop: '7%' } }))
                    : ''),
                this.props.Main ?
                    React.createElement("div", { style: { marginBottom: '8%', marginTop: '15%', textAlign: 'center', paddingTop: '45px' } },
                        React.createElement("div", { className: 'MainText', style: { marginLeft: 'auto', textAlign: 'center' } }, this.props.Main),
                        React.createElement("div", { style: { letterSpacing: '.10em', fontSize: '1.1rem' } }, this.props.Secondary)) : React.createElement("div", null, " "),
                React.createElement("div", null,
                    React.createElement("div", { className: 'S-Grid grid__gutters grid__1of4 grid__space-around animate-top', style: this.props.Profile ?
                            { margin: 'auto', padding: '40px', paddingTop: '5px', marginLeft: '0' } : // style based on whether we are on a profile or not
                            { margin: 'auto', padding: '40px', paddingTop: '5px', marginLeft: '0%' } }, postList.allPostList))));
        }
        return (React.createElement(InfiniteScroll, { pageStart: 0, loadMore: this.scrollLoad, hasMore: this.state.hasMorePosts, useWindow: true },
            React.createElement("div", null, displayWriting && !tag
                ? (React.createElement("div", { style: { display: 'block', textAlign: 'center', width: '95%', margin: 'auto', marginTop: '13%', backgroundColor: '', padding: '10px' } },
                    React.createElement("div", { style: { width: '75%', margin: 'auto' } }),
                    this.props.Main ?
                        React.createElement("div", { style: { marginTop: '23%', marginBottom: '23%', textAlign: 'center', padding: '20px 0 0 0' } },
                            React.createElement("div", { className: 'MainText', style: { marginLeft: 'auto', textAlign: 'center' } }, this.props.Main),
                            React.createElement("div", { style: { fontFamily: 'GT Sectra Book', letterSpacing: '.10em', fontSize: '1.1rem' } }, this.props.Secondary)) : React.createElement("div", null, " ")))
                : ''),
            React.createElement("div", { className: 'S-Grid' }, postList.allPostList)));
    };
    StreamComponent.propTypes = {
        /**
         * If it's true , writing post block will be visible
         */
        displayWriting: PropTypes.bool.isRequired,
        /**
         * A list of post
         */
        posts: PropTypes.object,
        /**
         * The title of home header
         */
        homeTitle: PropTypes.string
    };
    return StreamComponent;
}(Component));
export { StreamComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        setHomeTitle: function () { return dispatch(globalActions.setHeaderTitle(ownProps.homeTitle || '')); },
        showTopLoading: function () { return dispatch(globalActions.showTopLoading()); },
        hideTopLoading: function () { return dispatch(globalActions.hideTopLoading()); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    var user = state.getIn(['user', 'info', uid]);
    var Scene = state.getIn(['renderer', 'StateScene']);
    var Camera = state.getIn(['renderer', 'StateCamera']);
    return {
        translate: getTranslate(state.get('locale')),
        avatar: user ? user.avatar : '',
        fullName: user ? user.fullName : '',
        isDesigner: user ? user.isDesigner : false,
        Scene: Scene,
        Camera: Camera
    };
};
// - Connect component to redux store
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StreamComponent));



//////////////////
// WEBPACK FOOTER
// ./src/containers/stream/GStream.tsx
// module id = 1568
// module chunks = 1 6 21 23